import React, { useContext, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
// import Typography from "@mui/material/Typography";
import ListItemAvatar from "@mui/material/ListItemAvatar";

import { StoreContext } from "./../../store/Store";
import { MdRemoveRedEye } from "react-icons/md";
import { TiFolderOpen } from "react-icons/ti";
import { useRedirect } from "react-admin";
import { routePaths } from "../../baseLayout/SidebarMenu";
import loginAvatar from "./../../static/login-avatar.png";
import { BsCircleFill } from "react-icons/bs";
import { theme } from "../../theme";
import { FiChevronRight } from "react-icons/fi";
import IEvent from "../../dataProvider/interfaces/IEvent";
import { BiEdit } from "react-icons/bi";
import { APIContext } from "../../store/APIStore";
import { getEventStatusColor } from "../../utils";
import { useHasPermissions } from "../../hooks/useHasPermissions";
import { PERMISSIONS } from "../../roles";
import FdAvatar from "../UIComponents/Avatar/FdAvatar";
import FdBadge from "../UIComponents/FdBadge/FdBadge";
import Typography from "@mui/material/Typography";
import {eventSelector as classes} from "./styles";

const EventSelector = () => {

    
  const redirect = useRedirect();
  const [state, dispatch] = useContext(StoreContext);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const api = useContext(APIContext);

  // permissions
  const canManageEvent = useHasPermissions(PERMISSIONS.CAN_MANAGE_EVENT);

  useEffect(() => {
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = () => {
    if (!state.eventsList) {
      fetchEventsList();
    }
  };

  const fetchSelectedEvent = async (eventId: number) => {
    try {
      const event = await api.eventService.getEvent({ id: eventId });
      dispatch({ type: "SET_SELECTED_EVENT", payload: event });
    } catch (error: any) {
      console.log(error);
    }
  };

  const fetchEventsList = async () => {
    try {
      if(state.currentUser) {
        const { data } = await api.eventService.getEvents({
          archived: false,
          start: 0,
          limit: 4,
        });
        dispatch({ type: "SET_EVENTS_LIST", payload: data });
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const goToActiveEvents = () => {
    handleClose();
    redirect(`/${routePaths.ACTIVE_EVENTS}`);
  };

  const goToArchivedEvents = () => {
    handleClose();
    redirect(`/${routePaths.ARCHIVED_EVENTS}`);
  };

  const selectEvent = (event: IEvent) => {
    dispatch({ type: "SET_SELECTED_EVENT", payload: event }); // use the existing loaded data to set the selected event before fetching it again
    redirect(`/${routePaths.EVENTS}/${event.id}/${routePaths.EDIT}`);
    fetchSelectedEvent(event.id); // fetch again the selected event
    handleClose();
  };

  const EventAvatar = () => {
    return (
      <Box display="flex" alignItems="center" sx={{'& .MuiBadge-badge':{'& svg':{height:'10px',width:'10px'}}}}>
        <FiChevronRight color={theme.palette.text.primary} />
        <FdBadge
          overlap="circular"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          badgeContent={
            <BsCircleFill
              size="10"
              color={
                state.selectedEvent
                  ? getEventStatusColor(state.selectedEvent.status)
                  : theme.palette.warning.main
              }
            />
          }
        >
          <FdAvatar
            src={
              state.selectedEvent ? state.selectedEvent.logoUrl : loginAvatar
            }
           sx={classes.eventItemAvatar}
          />
        </FdBadge>
      </Box>
    );
  };

  const getEventsList = (events: IEvent[]) => {
    let eventsList = [...events];
    if (state.selectedEvent) {
      eventsList = events.filter(
        (event) => event.id !== state.selectedEvent.id
      );
    }
    return eventsList.slice(0, 3).map((event) => {
      return (
        <MenuItem
          sx={classes.item}
          onClick={() => {
            selectEvent(event);
          }}
          key={event.id}
        >
          <ListItemIcon sx={classes.eventItem}>
            <Badge
              overlap="circular"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              badgeContent={
                <BsCircleFill
                  size="10"
                  color={getEventStatusColor(event.status)}
                />
              }
            >
              <Avatar
               sx={classes.eventItemAvatar}
                src={event.logoUrl || loginAvatar}
                alt="event-avatar"
              />
            </Badge>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography component="p" sx={classes.eventTitle} aria-label="fd-eventname">
                {event.name}
              </Typography>
            }
            // secondary={
            //   <Typography variant="body2" component="p" color="common.black" sx={classes.eventStatus}>
            //     Status: {event.status}
            //   </Typography>
            // }
          ></ListItemText>
        </MenuItem>
      );
    });
  };

  return (
    <Box height="60px" display="flex" alignItems="center">
      <Button
        sx={classes.button}
        aria-controls="event-selector"
        aria-haspopup="true"
        onClick={handleClick}
        startIcon={<EventAvatar />}
      >
        <Box sx={classes.mainDiv}>
          <Typography sx={classes.eventTitle} component="p">
            {state.selectedEvent
              ? state.selectedEvent.name
              : "No event selected"}
          </Typography>
          {/* <Typography variant="body2"  color="common.black" >
            Status:{" "}
            {state.selectedEvent ? state.selectedEvent.status : "On hold"}
          </Typography> */}
        </Box>
      </Button>
      <Menu
        id="event-selector"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
        //TODO: commented for mui v5
        // getContentAnchorEl={null}
        TransitionProps={{
          onEnter: () => {
            fetchEventsList();
          }
        }}
        sx={classes.eventSelectorMenu}
        >
        {state.eventsList && getEventsList(state.eventsList)}
        {canManageEvent && (
          <MenuItem
            // sx={classes.item}
            onClick={() => {
              redirect(`/${routePaths.NEW_EVENT}`);
            }}
            
          >
            <ListItemAvatar sx={classes.selectorMenuItemAvatar}>
          <Avatar sx={{background: theme.palette.primary.main,}}>
          <BiEdit />
          </Avatar>
        </ListItemAvatar>
            {/* <ListItemIcon className={classes.allEventsIcon}>
            <BiEdit />
            </ListItemIcon> */}
            <ListItemText primary="Create new event" />
          </MenuItem>
        )}
        <MenuItem onClick={goToActiveEvents}>
        <ListItemAvatar sx={classes.selectorMenuItemAvatar}>
          <Avatar sx={{background: theme.palette.primary.main, }}>
          <MdRemoveRedEye />
          </Avatar>
        </ListItemAvatar>
          {/* <ListItemIcon className={classes.allEventsIcon}>
            <MdRemoveRedEye />
          </ListItemIcon> */}
          <ListItemText primary="See all your events" />
        </MenuItem>
        <MenuItem onClick={goToArchivedEvents}>
        <ListItemAvatar sx={classes.selectorMenuItemAvatar}>
          <Avatar>
          <TiFolderOpen />
          </Avatar>
        </ListItemAvatar>
          {/* <ListItemIcon className={classes.archivedEventsIcon}>
            <TiFolderOpen />
          </ListItemIcon> */}
          <ListItemText primary="Archived Events" />
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default EventSelector;
